import { useSuspenseQuery as useSuspendableQuery } from '@apollo/client';

export { useSuspendableQuery };
export default useSuspendableQuery;
